export default __webpack_public_path__ + "static/media/poster.c122d380.jpg";